/** Marks a SliderGallery root so nested sliders can ignore each other's swipe gestures. */
export const SLIDER_GALLERY_ROOT_ATTR = "data-pg-slider-gallery";

/** Movement below this (px) is treated as a tap, not a swipe. */
export const GESTURE_SWIPE_DEADBAND = {
    DEFAULT: 10,
    /** Higher threshold for fullscreen viewers where pinch-to-zoom must not change slides. */
    VIEWER: 40
} as const;
/** Marks a SliderGallery root so nested sliders can ignore each other's swipe gestures. */
export const SLIDER_GALLERY_ROOT_ATTR = "data-pg-slider-gallery";

/** Movement below this (px) is treated as a tap, not a swipe. */
export const GESTURE_SWIPE_DEADBAND = {
    DEFAULT: 10,
    /** Higher threshold for fullscreen viewers where pinch-to-zoom must not change slides. */
    VIEWER: 40
} as const;
